import { Inject } from '@odinjs/odin';
import { ImageAPI, PDFViewerAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { resolvePath } from '@philips-internal/oswald-ui-utils';
import { FragmentNames } from '../../codegen';
import { PreviewAttachedFileAliases } from '../../codegen';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import BaseController from '../BaseController';

import './preview-attached-file-controller.css';

interface CurrentRouteQueryParams {
  uri: string;
}

const ALLOWED_EXTENTIONS = {
  JPEG: /.jpeg$/,
  JPG: /.jpg$/,
  PDF: /.pdf$/,
  PNG: /.png$/,
}
@Controller({ fragment: FragmentNames.PREVIEW_ATTACHED_FILE })
export default class PreviewAttachedFileController extends BaseController {

  @Inject(PreviewAttachedFileAliases.PDF_VIEWER)
    pdfViewerAPI!: PDFViewerAPI;

  @Inject(PreviewAttachedFileAliases.IMAGE)
    imageAPI!: ImageAPI;

  @OnMount(PreviewAttachedFileAliases.LAYOUT_PREVIEW_FILE)
  handleLoadingLayout(): void {
    const { uri } = this.historyService.getCurrentRouteQueryParams() as unknown as CurrentRouteQueryParams;
    this.renderPreviewOnScreen(uri);
  }

  private renderPreviewOnScreen(uri: string): void {

    if(!uri) {
      return;
    }

    const endpoint = resolvePath(`${APPLICATION_ENDPOINTS.GET_PREVIEW_DOCUMENT}?uri=:uri`, { uri });
    switch(true) {
      case ALLOWED_EXTENTIONS.PDF.test(uri):
        this.pdfViewerAPI.setVisible(true);
        this.pdfViewerAPI.setSrc(endpoint);
        break;
      case ALLOWED_EXTENTIONS.JPEG.test(uri):
      case ALLOWED_EXTENTIONS.JPG.test(uri):
      case ALLOWED_EXTENTIONS.PNG.test(uri):
        this.imageAPI.setVisible(true);
        this.imageAPI.setSrc(endpoint);
        break;
      default:
        throw Error('Unsupported document extension.');
    }
  }
}